import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { SeEnvironment } from "@/types";

export interface ApiKeyState {
    apiKey: string | null;
    environment: SeEnvironment | null;
}

const initialState: ApiKeyState = {
    apiKey: null,
    environment: null,
};

const apiKeySlice = createSlice({
    name: "apiKey",
    initialState,
    reducers: {
        setApiKey(state, action: PayloadAction<string>) {
            state.apiKey = action.payload;
        },
        setEnvironment(state, action: PayloadAction<SeEnvironment>) {
            state.environment = action.payload;
        },
    },
});

export const { setApiKey, setEnvironment } = apiKeySlice.actions;
export default apiKeySlice.reducer;
